import taiwanList from './areas/taiwan.json'
import southeastAsiaLst from './areas/southeast_asia.json'
import worldList from './areas/world.json'

const taiwan = taiwanList.map(area => area.value)
const southeastAsia = southeastAsiaLst.map(area => area.value)
const world = worldList.map(area => area.value)

// ### 地區定義 ###
// 1.台灣: 台灣內的縣市
// 2.東亞: 東亞的國家，除了台灣
// 3.世界: 世界全部國家，除了東亞跟台灣
// 4.全部: 世界全部國家，包含東亞跟台灣
// Refer1: https://www.worldometers.info/geography/alphabetical-list-of-countries/
// Refer2: https://www.nationsonline.org/oneworld/country_code_list.htm

export const areaCategory = {
  taiwan,
  others: [...southeastAsia, ...world]
}

export const range = [
  { name: '臺灣', value: 'taiwan' },
  { name: '東亞', value: 'southeastAsia' },
  { name: '世界', value: 'world' },
  { name: '全部', value: 'all' }
]

export const country = {
  taiwan,
  southeastAsia,
  world,
  all: [
    ...taiwan,
    ...southeastAsia,
    ...world
  ]
}

// export default {
//   臺灣: [
//     ...taiwan
//   ],
//   其他國家: [...southeastAsia, ...world].sort()
// }

// 全部其他國家列表
// [
//   'Afghanistan',
//   'Albania',
//   'Algeria',
//   'Andorra',
//   'Angola',
//   'Antigua and Barbuda',
//   'Argentina',
//   'Armenia',
//   'Australia',
//   'Austria',
//   'Azerbaijan',
//   'Bahamas',
//   'Bahrain',
//   'Bangladesh',
//   'Barbados',
//   'Belarus',
//   'Belgium',
//   'Belize',
//   'Benin',
//   'Bhutan',
//   'Bolivia',
//   'Bosnia and Herzegovina',
//   'Botswana',
//   'Brazil',
//   'Brunei',
//   'Bulgaria',
//   'Burkina Faso',
//   'Burundi',
//   "Côte d'Ivoire",
//   'Cabo Verde',
//   'Cambodia',
//   'Cameroon',
//   'Canada',
//   'Central African Republic',
//   'Chad',
//   'Chile',
//   'China',
//   'Colombia',
//   'Comoros',
//   'Congo (Congo-Brazzaville)',
//   'Costa Rica',
//   'Croatia',
//   'Cuba',
//   'Cyprus',
//   'Czechia (Czech Republic)',
//   'Democratic Republic of the Congo',
//   'Denmark',
//   'Djibouti',
//   'Dominica',
//   'Dominican Republic',
//   'Ecuador',
//   'Egypt',
//   'El Salvador',
//   'Equatorial Guinea',
//   'Eritrea',
//   'Estonia',
//   "Eswatini (fmr. 'Swaziland')",
//   'Ethiopia',
//   'Fiji',
//   'Finland',
//   'France',
//   'Gabon',
//   'Gambia',
//   'Georgia',
//   'Germany',
//   'Ghana',
//   'Greece',
//   'Grenada',
//   'Guatemala',
//   'Guinea',
//   'Guinea-Bissau',
//   'Guyana',
//   'Haiti',
//   'Holy See',
//   'Honduras',
//   'Hungary',
//   'Iceland',
//   'India',
//   'Indonesia',
//   'Iran',
//   'Iraq',
//   'Ireland',
//   'Israel',
//   'Italy',
//   'Jamaica',
//   'Japan',
//   'Jordan',
//   'Kazakhstan',
//   'Kenya',
//   'Kiribati',
//   'Kuwait',
//   'Kyrgyzstan',
//   'Laos',
//   'Latvia',
//   'Lebanon',
//   'Lesotho',
//   'Liberia',
//   'Libya',
//   'Liechtenstein',
//   'Lithuania',
//   'Luxembourg',
//   'Madagascar',
//   'Malawi',
//   'Malaysia',
//   'Maldives',
//   'Mali',
//   'Malta',
//   'Marshall Islands',
//   'Mauritania',
//   'Mauritius',
//   'Mexico',
//   'Micronesia',
//   'Moldova',
//   'Monaco',
//   'Mongolia',
//   'Montenegro',
//   'Morocco',
//   'Mozambique',
//   'Myanmar',
//   'Namibia',
//   'Nauru',
//   'Nepal',
//   'Netherlands',
//   'New Zealand',
//   'Nicaragua',
//   'Niger',
//   'Nigeria',
//   'North Korea',
//   'North Macedonia',
//   'Norway',
//   'Oman',
//   'Pakistan',
//   'Palau',
//   'Palestine State',
//   'Panama',
//   'Papua New Guinea',
//   'Paraguay',
//   'Peru',
//   'Philippines',
//   'Poland',
//   'Portugal',
//   'Qatar',
//   'Romania',
//   'Russia',
//   'Rwanda',
//   'Saint Kitts and Nevis',
//   'Saint Lucia',
//   'Saint Vincent and the Grenadines',
//   'Samoa',
//   'San Marino',
//   'Sao Tome and Principe',
//   'Saudi Arabia',
//   'Senegal',
//   'Serbia',
//   'Seychelles',
//   'Sierra Leone',
//   'Singapore',
//   'Slovakia',
//   'Slovenia',
//   'Solomon Islands',
//   'Somalia',
//   'South Africa',
//   'South Korea',
//   'South Sudan',
//   'Spain',
//   'Sri Lanka',
//   'Sudan',
//   'Suriname',
//   'Sweden',
//   'Switzerland',
//   'Syria',
//   'Tajikistan',
//   'Tanzania',
//   'Thailand',
//   'Timor-Leste',
//   'Togo',
//   'Tonga',
//   'Trinidad and Tobago',
//   'Tunisia',
//   'Turkey',
//   'Turkmenistan',
//   'Tuvalu',
//   'Uganda',
//   'Ukraine',
//   'United Arab Emirates',
//   'United Kingdom',
//   'United States of America',
//   'Uruguay',
//   'Uzbekistan',
//   'Vanuatu',
//   'Venezuela',
//   'Vietnam',
//   'Yemen',
//   'Zambia',
//   'Zimbabwe'
// ]
